module.exports = __webpack_public_path__ + "static/media/CooperHewitt-Book.4975ba5c.woff";